import { Button } from "@/components/ui/button";

// The ErrorBoundary has already reported by the time this renders, so this is
// UI only — it must never log again or it double-counts the error.
//
// The release id is on screen deliberately: a support screenshot then carries
// the exact build, which is otherwise the single most expensive thing to
// establish about a crash report.
export function AppCrashFallback({
  error,
  reset,
}: {
  error: Error;
  reset: () => void;
}) {
  return (
    <div className="mx-auto grid min-h-dvh max-w-md place-items-center px-6">
      <div>
        <p className="font-mono text-[10px] tracking-[0.18em] text-fg-muted">
          Character Studio
        </p>
        <h1 className="mt-3 text-2xl font-bold tracking-tight">
          Something went wrong.
        </h1>
        <p className="mt-3 text-sm leading-relaxed text-fg-muted">
          This page couldn&apos;t load. Try again to reload it.
        </p>
        {import.meta.env.DEV && (
          <pre className="mt-4 overflow-auto rounded-lg bg-bg-elevated p-3 font-mono text-[11px] text-fg-muted">
            {error.message}
          </pre>
        )}
        <Button
          type="button"
          className="mt-5 h-12 w-full rounded-xl text-[15px] font-bold"
          onClick={reset}
        >
          Try again
        </Button>
        <p className="mt-4 font-mono text-[10px] text-fg-subtle">
          build {import.meta.env.VITE_RELEASE_ID || "dev"}
        </p>
      </div>
    </div>
  );
}
